import { render } from "./BigSpinner.svg?vue&type=template&id=4c75251c"
const script = {}
script.render = render

export default script